import React from "react";
import cn from "classnames";
import Button from "components/UI/Button";
import styles from "./styles.module.scss";
import { AnimationHome } from "../../Animation";
import { track } from "../../../utils/amplitude";
import Link from "next/link";

const Main = ({
  title,
  titleStyles,
  fixedWidth = false,
  description,
  descriptionStyles,
  content = null,
  long = false,
  absolute = false,
  mainLong = false,
  withBtns = false,
  actions = false,
  showImage = false,
}) => {
  return (
    <div className={styles.main}>
      <div className={cn("container")}>
        <div className={styles.row}>
          <div
            style={{ maxWidth: fixedWidth ? 700 : "inherit" }}
            className={cn(styles.content, { long, ["main-long"]: mainLong })}
          >
            <h1 className={cn(titleStyles)}>{title}</h1>
            <p className={cn(descriptionStyles)}>{description}</p>
            {withBtns && (
              <div className={styles.btns}>
                {actions || (
                  <>
                    <a
                      href="https://app.apphud.com/sign_up"
                      onClick={() =>
                        track("sign_up_button_clicked", { block: "top_link" })
                      }
                    >
                      <Button title="Sign up for free" />
                    </a>
                    <Link
                      href="/demo"
                      target="_blank"
                      onClick={() =>
                        track("demo_request_link_clicked", {
                          block: "top_link",
                        })
                      }
                    >
                      <Button title="Get a demo" transparent />
                    </Link>
                  </>
                )}
              </div>
            )}
          </div>
          <div
            style={{
              display: showImage ? "block" : "inherit",
              margin: "0 auto",
            }}
            className={cn(styles.image, { absolute, ["main-long"]: mainLong })}
          >
            {content || <AnimationHome />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
